import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Accordion, AccordionDetails, AccordionSummary, Alert, Button, ButtonProps, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, InputLabel, ListItemIcon, ListItemText, Menu, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import Layout from '../components/Utilities/Layout';
import StackedBarChartOutlinedIcon from '@mui/icons-material/StackedBarChartOutlined';
import Common from '../utilities/common';
import { DataGrid, GridColumnHeaderParams, GridCsvExportOptions, GridCsvGetRowsToExportParams, GridRenderCellParams, GridRowSelectionModel, GridToolbarContainer, gridExpandedSortedRowIdsSelector, useGridApiContext } from '@mui/x-data-grid';
import Man2OutlinedIcon from '@mui/icons-material/Man2Outlined';
import Woman2OutlinedIcon from '@mui/icons-material/Woman2Outlined';
import $ from "jquery";
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import WcIcon from '@mui/icons-material/Wc';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import SignpostOutlinedIcon from '@mui/icons-material/SignpostOutlined';
import TrafficOutlinedIcon from '@mui/icons-material/TrafficOutlined';
import MarkunreadMailboxOutlinedIcon from '@mui/icons-material/MarkunreadMailboxOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import LightOutlinedIcon from '@mui/icons-material/LightOutlined';
import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';

import EditIcon from '@mui/icons-material/Edit';
import EntityPermissions from '../components/EntityPermissions';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import DataSearchForm, { SearchModel } from './DataSearchForm';
import EntitySettings from '../components/EntitySettings';
import { Cliente } from '../Clientes/Cliente';

export class ExtraccionData {
    public fallow: number | undefined;
    public rows: number | undefined;
    public type: string | undefined = 'first';
}

export interface IDataViewProps {
    permission?: string
}

export interface IDataViewState {
    data: any[];
    filteredData: any[];
    fieldsWithErrors: string[];
    loading: boolean;
    iconButtonPressed: null | HTMLElement;
    openRowMenu: boolean;
    selectedRow: any;
    openExtractDialog: boolean;
    clientes: Cliente[];
    selectedClient: any;
    extractData: ExtraccionData;
}

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const CustomToolbar = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
      <GridToolbarContainer>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'daatos' })}
        >
          Exportar CSV
        </Button>
      </GridToolbarContainer>
    );
}

export default class DataView extends React.Component<IDataViewProps, IDataViewState> {
    _clienteId: number = -1;
    _searchModel: SearchModel[] = [];

    public constructor(props: IDataViewProps) {
        super(props);

        this.state = {
            data: [],
            filteredData: [],
            fieldsWithErrors: [],
            loading: true,
            iconButtonPressed: null,
            openRowMenu: false,
            selectedRow: null,
            openExtractDialog: false,
            clientes: [],
            selectedClient: null,
            extractData: new ExtraccionData()
        }
    }

    componentDidMount(): void {
        this.Get();
        this.GetClientes();
    }

    public render(): React.ReactElement<{}> {
        return (
            <SecurityTrimmer entity={Entity.Datos} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Datos',
                            url: ''
                        }
                    ]
                }>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <StackedBarChartOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                Datos
                                </Typography>
                            </Grid>
                            <SecurityTrimmer entity={Entity.Datos} permission={PermissionLevel.Administrar}>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntitySettings entity={Entity.Datos}/>
                                </Grid>
                            </SecurityTrimmer>
                        </Grid>
                    </Box>
                    <Box className='main'>
                        <div style={{textAlign: 'right', marginBottom: '20px'}}>
                            <FormControl variant="standard" style={{width: '200px'}} error>
                                <InputLabel id="labelErrores">Errores</InputLabel>
                                <Select label="Errores" defaultValue='all' labelId='labelErrores' style={{textAlign: 'left'}} onChange={(event: SelectChangeEvent) => {
                                    if(event.target.value == 'all') {
                                        this.ViewErrors(null);
                                    }
                                    else {
                                        this.ViewErrors(event.target.value);
                                    }
                                }}>
                                    <MenuItem value={'all'}>
                                        Ver todo
                                    </MenuItem>
                                    {
                                        this.state.fieldsWithErrors.map((value: string, index: number) => {
                                            return (
                                                <MenuItem value={value} key={index} >
                                                    {
                                                        Common.GetFieldDisplayName(value)
                                                    }
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </div>
                        <DataGrid
                            slots={{ toolbar: CustomToolbar }}
                            autoHeight
                            loading={this.state.loading}
                            rows={this.state.filteredData}
                            slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                            columns={[
                                { 
                                    field: 'id', 
                                    headerName: '', 
                                    width: 50,
                                    renderCell: ({ row }) => (
                                        this.RenderIconStatus(row)
                                    )
                                },
                                { 
                                    field: 'nombre', 
                                    headerName: 'Nombre', 
                                    width: 250,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'nombre')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'apellidos', 
                                    headerName: 'Apellidos', 
                                    width: 250,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'apellidos')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'telefono', 
                                    headerName: 'Telefono', 
                                    width: 150,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'telefono')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'tipoVia', 
                                    headerName: 'Tipo de vía', 
                                    width: 150,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'tipoVia')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'nombreVia', 
                                    headerName: 'Nombre de la vía', 
                                    width: 250,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'nombreVia')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'numeroVia', 
                                    headerName: 'Número', 
                                    width: 100,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'numeroVia')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'restoDireccion', 
                                    headerName: 'Resto dirección', 
                                    width: 250,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'restoDireccion')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'cp', 
                                    headerName: 'CP', 
                                    width: 250,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'cp')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'municipio', 
                                    headerName: 'Municipio', 
                                    width: 250,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'municipio')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'provincia', 
                                    headerName: 'Provincia', 
                                    width: 250,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'provincia')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'fechaNacimiento', 
                                    headerName: 'Fecha de nacimiento', 
                                    width: 200,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'fechaNacimiento')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'email', 
                                    headerName: 'Email', 
                                    width: 250,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'email')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'sexo', 
                                    headerName: 'Sexo', 
                                    width: 100,
                                    renderCell: ({ row }) => (
                                        <div>
                                            {
                                                row.sexo?.toLowerCase() == 'h' && (
                                                    <Man2OutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                                                )
                                            }
                                            {
                                                row.sexo?.toLowerCase() == 'm' && (
                                                    <Woman2OutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                                                )
                                            }
                                        </div>
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'cupsLuz', 
                                    headerName: 'Cups Luz', 
                                    width: 250,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'cupsLuz')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'cupsGas', 
                                    headerName: 'Cups Gas', 
                                    width: 250,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'cupsGas')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'url', 
                                    headerName: 'URL', 
                                    width: 250,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'url')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                },
                                { 
                                    field: 'ip', 
                                    headerName: 'IP', 
                                    width: 250,
                                    renderCell: ({ row }) => (
                                        this.RenderCell(row, 'ip')
                                    ),
                                    renderHeader: this.RenderHeader.bind(this)
                                }
                            ]}
                            initialState={{
                                pagination: {
                                    paginationModel: { page: 0, pageSize: 30 },
                                },
                            }}
                            pageSizeOptions={[30, 60, 100, 250, 300]}
                            hideFooter={this.state.filteredData.length <= 30}
                        />
                    </Box>
                    
                    <Menu
                        id="basic-menu"
                        anchorEl={this.state.iconButtonPressed}
                        open={this.state.openRowMenu}
                        onClose={() => {
                            this.setState(
                                {
                                    iconButtonPressed: null,
                                    openRowMenu: false
                                }
                            );
                        }}
                    >
                        <MenuItem onClick={() => {
                            this.setState(
                                {
                                    iconButtonPressed: null,
                                    openRowMenu: false
                                }
                            );
                        }}>
                            <ListItemIcon>
                                <EditIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Editar</ListItemText>
                        </MenuItem>
                    </Menu>
                </Layout>
                <Dialog open={this.state.openExtractDialog} fullWidth>
                    <DialogTitle>
                        Extracción de datos
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant='body2'>
                            Seleccione el cliente para el que desea realizar la extracción de datos.
                        </Typography>
                        <FormControl required fullWidth variant="standard">
                            <Select onChange={(event: SelectChangeEvent) => {
                                this._clienteId = Number(event.target.value);
                                this.GetClientData();
                            }}>
                                {
                                    this.state.clientes.map((value: Cliente, index: number) => {
                                        return (
                                            <MenuItem value={value.id}>
                                                {
                                                    value.razonSocial
                                                }
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                        {
                            this.state.selectedClient != null && (
                                <div className='extractClientData'>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant='body2' fontWeight={500}>
                                                Vertical:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Typography variant='body2'>
                                            {
                                                this.state.selectedClient.vertical
                                            }
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant='body2' fontWeight={500}>
                                                Barbecho por cliente:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Typography variant='body2'>
                                            {
                                                !isNaN(this.state.selectedClient.clientDefaultFallow) && (
                                                    <Typography variant='body2'>
                                                    {
                                                        `${this.state.selectedClient.clientDefaultFallow} días`
                                                    }
                                                    </Typography>
                                                )
                                            }
                                            {
                                                isNaN(this.state.selectedClient.clientDefaultFallow) && (
                                                    <Typography variant='body2'>
                                                    No especificado
                                                    </Typography>
                                                )
                                            }
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant='body2' fontWeight={500}>
                                                Barbecho por vertical:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            {
                                                !isNaN(this.state.selectedClient.verticalDefaultFallow) && (
                                                    <Typography variant='body2'>
                                                    {
                                                        `${this.state.selectedClient.verticalDefaultFallow} días`
                                                    }
                                                    </Typography>
                                                )
                                            }
                                            {
                                                isNaN(this.state.selectedClient.verticalDefaultFallow) && (
                                                    <Typography variant='body2'>
                                                    No especificado
                                                    </Typography>
                                                )
                                            }
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant='body2' fontWeight={500}>
                                                Registros a exportar:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <FormControl fullWidth>
                                                <TextField variant='standard' type='number' defaultValue={this.state.data.length} value={this.state.extractData.rows} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                    const extractData = this.state.extractData;
                                                    extractData.rows = Number(event.target.value);
                                                    this.setState(
                                                        {
                                                            extractData: extractData
                                                        }
                                                    )
                                                }}/>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant='body2' fontWeight={500}>
                                                Barbecho (en días):
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <FormControl fullWidth>
                                                <TextField variant='standard' type='number' defaultValue={this.state.extractData.fallow} value={this.state.extractData.fallow} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                    const extractData = this.state.extractData;
                                                    extractData.fallow = Number(event.target.value);
                                                    this.setState(
                                                        {
                                                            extractData: extractData
                                                        }
                                                    )
                                                }}/>
                                            </FormControl>
                                        </Grid>
                                        {
                                            this.state.extractData.rows != null && (this.state.extractData.rows! < this.state.data.length) && (
                                                <React.Fragment>
                                                    <Grid item xs={4}>
                                                        <Typography variant='body2' fontWeight={500}>
                                                            Selección de registros:
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <FormControl fullWidth>
                                                            <Select variant='standard' defaultValue='first' value={this.state.extractData.type} onChange={(event: SelectChangeEvent) => {
                                                                const extractData = this.state.extractData;
                                                                extractData.type = event.target.value;
                                                                this.setState(
                                                                    {
                                                                        extractData: extractData
                                                                    }
                                                                )
                                                            }}>
                                                                <MenuItem value={'first'}>
                                                                    {
                                                                        `${this.state.extractData.rows} primeros registros`
                                                                    }
                                                                </MenuItem>
                                                                <MenuItem value={'last'}>
                                                                {
                                                                        `${this.state.extractData.rows} últimos registros`
                                                                    }
                                                                </MenuItem>
                                                                <MenuItem value={'random'}>
                                                                    Aleatorio
                                                                </MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </React.Fragment>
                                            )
                                        }
                                        {
                                            this.state.extractData.rows != null && (this.state.extractData.rows! > this.state.data.length) && (
                                                <React.Fragment>
                                                    <Grid item xs={12}>
                                                        <Alert severity='info'>
                                                            Ha seleccionado más registros de los disponibles para la extracción, por lo que se utilizarán los registros en barbecho para completar el número de registros indicado
                                                        </Alert>
                                                    </Grid>
                                                </React.Fragment>
                                            )
                                        }
                                    </Grid>
                                </div>
                            )
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Ok.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
            </SecurityTrimmer>
        )
    }

    private GetClientData() {
        let url = `${Common.END_POINT}/clientes/${this._clienteId}/getextractiondata`;
        $.ajax((
            {
                url: url,
                type: "GET",
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log('GetClientData', response);
            const extractData = this.state.extractData;
            extractData.fallow = !isNaN(response[0].clientDefaultFallow) ? response[0].clientDefaultFallow : response[0].verticalDefaultFallow;
            extractData.rows = this.state.data.length;

            this.setState(
                {
                    extractData: extractData
                }
            )
            this.setState(
                {
                    selectedClient: response[0],
                    extractData: extractData
                }
            )
        }).fail((jqXHR, textStatus, errorThrown) => {
            
        });
    }

    private Ok() {
        let url = `${Common.END_POINT}/extracciones/${this._clienteId}/${this.state.extractData.type}/${this.state.extractData.rows}/${this.state.extractData.fallow}`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._searchModel),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            window.location.href = '/extracciones';
        }).fail((jqXHR, textStatus, errorThrown) => {
            
        });
    }

    private Close() {
        this.setState(
            {
                openExtractDialog: false,
                extractData: new ExtraccionData(),
                selectedClient: null
            }
        )
    }

    private Get(): void {
        this.setState({
            loading: true
        });

        let url = `${Common.END_POINT}/data`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            let fieldsWithErrors = this.state.fieldsWithErrors;

            for(let i = 0; i < response.length; i++) {
                for(let key in response[i]) {
                    if(response[i][key] == null || response[i][key] == '' || response[i][key].toString().indexOf == undefined) {
                        if(fieldsWithErrors.indexOf(key) == -1) {
                            fieldsWithErrors.push(key);
                        }
                    }
                }
            }

            this.setState(
                {
                    data: response,
                    fieldsWithErrors: fieldsWithErrors,
                    filteredData: response,
                    loading: false
                }
            );
        })
    }

    private GetClientes(): void {
        let url = `${Common.END_POINT}/clientes`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: Cliente[]) => {
            console.log('Cliente', response);
            this.setState(
                {
                    clientes: response
                }
            );
        })
    }

    private ViewErrors(filterBy: string | null) {
        if(filterBy == null) {
            this.setState(
                {
                    filteredData: this.state.data
                }
            );

            return;
        }

        let filteredData: any[] = [];

        if(filterBy != null) {
            filteredData = this.state.data.filter((value: any) => {
                return value[filterBy] == null || value[filterBy] == '' || value[filterBy].toString().indexOf == undefined
            })    
        }

        console.log('filteredData', filteredData);

        this.setState(
            {
                filteredData: filteredData
            }
        );
    }

    private RenderIconStatus(row: any): JSX.Element {
        return (
            <SecurityTrimmer entity={Entity.Datos} permission={PermissionLevel.Editar}>
                <div className='textCenter'>
                    <IconButton onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                        this.setState(
                            {
                                iconButtonPressed: event.currentTarget,
                                openRowMenu: true,
                                selectedRow: row
                            }
                        );
                    }}>
                        <MoreVertOutlinedIcon/>
                    </IconButton>
                </div>
            </SecurityTrimmer>
        )
    }

    private RenderCell(row: any, key: string): JSX.Element {
        let hasErrors: boolean = (row[key] == null || row[key] == '' || row[key].indexOf == undefined);

        return (
            <div style={{textAlign: key == 'cp' || key == 'numeroVia' || key == 'telefono' ? 'center' : 'left'}}>
                {
                    hasErrors && (
                        <Alert severity="error">
                            Sin datos
                        </Alert>
                    )
                }
                {
                    !hasErrors && row[key].indexOf != undefined && (
                        row[key]
                    )
                }
            </div>
        )
    }

    private RenderHeader(params: GridColumnHeaderParams): JSX.Element {
        return (
            <React.Fragment>
                {
                    (params.colDef.field == "nombre" || params.colDef.field == "apellidos") && (
                        <BadgeOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "sexo" && (
                        <WcIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "fechaNacimiento" && (
                        <CakeOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "telefono" && (
                        <LocalPhoneOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "tipoVia" && (
                        <TrafficOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "nombreVia" && (
                        <SignpostOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "numeroVia" && (
                        <ConfirmationNumberOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "restoDireccion" && (
                        <BusinessOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "municipio" && (
                        <HolidayVillageOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "provincia" && (
                        <LocationCityOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "cp" && (
                        <MarkunreadMailboxOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "email" && (
                        <AlternateEmailOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "cupsLuz" && (
                        <LightOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "cupsGas" && (
                        <LocalFireDepartmentOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                <strong style={{display: 'inline-block', marginLeft: '5px'}}>
                {
                    params.colDef.headerName
                }
                </strong>
            </React.Fragment>
        )
    }
}